export const esc = (s) => (s || "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
export const num = (v) => { const n = parseFloat(String(v ?? "").replace(/\s/g, "").replace(",", ".")); return isNaN(n) ? 0 : n; };

export const mdToHtml = (md) => (md || "").split(/\r?\n/).map((l) => {
  const t = l.replace(/\*\*/g, "").trimEnd();
  const tr = t.trim();
  if (tr.startsWith("### ")) return `<h3>${esc(tr.slice(4))}</h3>`;
  if (tr.startsWith("## ")) return `<h2>${esc(tr.slice(3))}</h2>`;
  if (tr.startsWith("# ")) return `<h1>${esc(tr.slice(2))}</h1>`;
  if (/^(-{3,}|\*{3,})$/.test(tr)) return "<hr>";
  if (tr.startsWith("- ") || tr.startsWith("* ")) return `<li>${esc(tr.slice(2))}</li>`;
  if (!tr) return "<br>";
  return `<p>${esc(tr)}</p>`;
}).join("");

export const htmlToText = (html) => {
  let s = html || "";
  s = s.replace(/<h1[^>]*>/gi, "\n# ").replace(/<\/h1>/gi, "\n");
  s = s.replace(/<h2[^>]*>/gi, "\n## ").replace(/<\/h2>/gi, "\n");
  s = s.replace(/<h[3-6][^>]*>/gi, "\n### ").replace(/<\/h[3-6]>/gi, "\n");
  s = s.replace(/<li[^>]*>/gi, "\n- ").replace(/<\/li>/gi, "");
  s = s.replace(/<hr\s*\/?>/gi, "\n");
  s = s.replace(/<\/p>/gi, "\n").replace(/<br\s*\/?>/gi, "\n").replace(/<\/div>/gi, "\n");
  s = s.replace(/<[^>]+>/g, " ");
  const ta = document.createElement("textarea"); ta.innerHTML = s; s = ta.value;
  return s.replace(/[ \t]{2,}/g, " ").replace(/\n{3,}/g, "\n\n").trim();
};

export const mdCell = (v) => String(v ?? "").replace(/\|/g, "/").replace(/\r?\n/g, " ");
